import { Component, COMPONENT_TYPE, User } from '@abiglobalhealth/go-types'

import { UserFormContextProps } from '@/contexts/userForm'

interface IsFieldFilledProps {
  component: Component
  user: User
  userUpdatedFields: UserFormContextProps['userUpdatedFields']
}

export const HIDABLE_COMPONENTS = [
  COMPONENT_TYPE.ROW,
  COMPONENT_TYPE.INPUT,
  COMPONENT_TYPE.SELECT,
  COMPONENT_TYPE.RADIO_GROUP,
  COMPONENT_TYPE.PHONE_NUMBER,
  COMPONENT_TYPE.COUNTRY_SELECT,
  COMPONENT_TYPE.CHECKBOX_GROUP
]

export const skipComponent = ({ component, user, userUpdatedFields }: IsFieldFilledProps): boolean => {
  // Don't skip if the component was updated on the current flow
  if (userUpdatedFields.includes(component.id as keyof typeof user.data)) return false

  if (component.componentType === COMPONENT_TYPE.ROW) {
    return Object.values(component.components)
      .map((subComponent) => skipComponent({ component: subComponent, user, userUpdatedFields }))
      .every((skipped) => skipped)
  }

  if (!('hideIfFilled' in component) || !component.hideIfFilled) return false

  const value = Boolean(user?.data?.[component.id as keyof typeof user.data])
  if ('hideIfFilled' in component && component.hideIfFilled && value) return true

  return false
}
